import React, { useState, useEffect } from "react";

import { Box, Button, Stack } from "@mui/material";

import useBrowser from "../../hooks/useBrowser";

import Modal from "./Modal";
import RichTextEditor from "../editors/RichTextEditor";

const RichTextEditorModal = ({ html = "", open, onClose, onChange }) => {
  const { windowHeight } = useBrowser();
  const [currentHtml, setCurrentHtml] = useState(html);

  // Keep editor content in sync when opening or when source html changes
  useEffect(() => {
    if (open) {
      setCurrentHtml(html || "");
    }
  }, [open, html]);

  const handleChange = (newHtml) => {
    setCurrentHtml(newHtml);
  };

  const handleSave = () => {
    if (onChange) onChange(currentHtml);
    onClose();
  };

  const handleCancel = () => {
    setCurrentHtml(html); // Reset to original
    onClose();
  };

  return (
    <Modal
      title="Rich Text Editor"
      open={open}
      onClose={onClose}
      width="600px"
      height={`${windowHeight}px`}
      contentOverflow="hidden"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: "16px 16px 36px",
          overflow: "hidden",
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, marginBottom: "16px" }}>
          <RichTextEditor
            html={currentHtml}
            onChange={handleChange}
            height="100%"
          />
        </Box>

        <Stack
          direction="row"
          gap={1}
          justifyContent="flex-end"
          sx={{ flexShrink: 0, paddingBottom: "8px" }}
        >
          <Button
            variant="outlined"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
          >
            Save
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default RichTextEditorModal;
